import jsPDF from 'jspdf';

import logo from "../assets/Images/WPM-Logo.png";

const convertDateFormat = (inputDate) => {
    const inputDateObj = new Date(inputDate);
  
    if (isNaN(inputDateObj)) {
      return 'Invalid date format';
    }
  
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
  
    const month = monthNames[inputDateObj.getMonth()];
    const day = inputDateObj.getDate();
    const year = inputDateObj.getFullYear();
  
    const formattedDate = `${month} ${day}, ${year}`;
  
    return formattedDate;
};

export const exportSchools = (pdfSchools) => {
    const width = 210;
    const height = 279;
    const pdf = new jsPDF({
        orientation: 'portrait', // Set the page orientation to portrait
        unit: 'mm', // Set the unit of measurement to millimeters
        format: [width, height], // Set the page size to A4
    });

    // Register the font with jsPDF
    pdf.addFont('calibri.ttf', 'calibri', 'normal');
    pdf.addFont('calibrib.ttf', 'calibri', 'bold');
    pdf.addFont('calibriz.ttf', 'italic', 'bold');

    const pos = {x: 15, y: 10};
    let pageNum = 1;

    const addPageNumber = (pageNum) => {
        pdf.setFontSize(10);
        pdf.setFont('calibri');
        pdf.text(`${pageNum}`, width - 10, height - 5);
    };

    const setPosY = (newY) => {
        if(newY > (height - 10)) {
            pos.y = 10;
            pdf.addPage();
            pageNum++; // Increment the page number
            addPageNumber(pageNum);
        } 
        else {
            pos.y = newY;
        }
    };

    pdfSchools.forEach((school, index) => {
        if(index !== 0 && pos.y > 10) {
            pdf.addPage([height, width], 'p');
            pos.y = 10;
            pageNum++; // Increment the page number
        }
        addPageNumber(pageNum);
        const poles = school.priority;
        
        // add logo and school details
        pdf.addImage(logo, 'JPEG',  pos.x + 2, pos.y + 3.5, 30, 12);
        pdf.setFontSize(8);
        pdf.setFont('calibri');
        const projectTittle = 'Katy ISD Light Pole Evaluation';
        pdf.text(`${school.schoolName}`, width-(pos.x*2)-pdf.getTextWidth(school.schoolName)+15, pos.y+ 10);
        pdf.text(`${projectTittle}`, width-(pos.x*2)-pdf.getTextWidth(projectTittle)+15, pos.y+ 13);
        pdf.text(`${convertDateFormat(school.currentDateTime)}`, width-(pos.x*2)-pdf.getTextWidth(convertDateFormat(school.currentDateTime))+15, pos.y+ 16);
        pos.y += 20;

        // add red headline
        pdf.setFillColor(220, 20, 60);
        pdf.rect(pos.x, pos.y, (width - (pos.x * 2)), 5, 'F');
        pdf.setTextColor(255);
        pdf.setFontSize(10);
        pdf.setFont('calibri');
        pdf.text('RECOMMENDATIONS', pos.x+2, pos.y+3.5);
        pos.y += 5;
        
        // add priority note
        const note = 'Our repair recommendations are separated into high, medium, and low priority repairs, defined as follows.';
        pdf.setTextColor(0);
        pdf.text(note, pos.x, pos.y+4);
        pos.y += 8;

        const highTitle = 'High Priority (less than 1 year):';
        const highText = ' High priority items are items that should be addressed immediately to maintain serviceability';
        const highText2 = 'of the associated item, maintain the safety of the light pole, or both. (Year 2022)';
        pdf.setFont('italic', 'bold');
        pdf.text(highTitle, pos.x, pos.y+4);
        pdf.setFont('calibri', 'normal');
        pdf.text(highText, pos.x+45, pos.y+4);
        pdf.text(highText2, pos.x, pos.y+8);
        pos.y += 10;

        const medTitle = 'Medium Priority (2 – 3 years):';
        const medText = ' Medium priority items are items that should be addressed in the near term to mitigate further';
        const medText2 = 'deterioration of the item and ensure the overall serviceability of the light pole is maintained. (Years 2023-2024)';
        pdf.setFont('italic', 'bold');
        pdf.text(medTitle, pos.x, pos.y+4);
        pdf.setFont('calibri', 'normal');
        pdf.text(medText, pos.x+44, pos.y+4);
        pdf.text(medText2, pos.x, pos.y+8);
        pos.y += 10;

        const lowTitle = 'Low Priority (4 – 5 years):';
        const lowText = 'Low priority items are items that should be addressed once the high and medium priority items';
        const lowText2 = 'have been repaired to sustain the overall serviceability of the light pole for the long-term. (Years 2025-2026)';
        pdf.setFont('italic', 'bold');
        pdf.text(lowTitle, pos.x, pos.y+4);
        pdf.setFont('calibri', 'normal');
        pdf.text(lowText, pos.x+38, pos.y+4);
        pdf.text(lowText2, pos.x, pos.y+8);
        pos.y += 15;

        // add poles
        poles.forEach(pole => {
            if(pole.high.length + pole.medium.length + pole.low.length > 0 || pole.poleReplacedOn) {
                // add gray headline with black bottom border
                pdf.setFillColor(233, 236, 239);
                pdf.rect(pos.x, pos.y, (width - (pos.x * 2)), 5, 'F');
                pdf.setDrawColor(0);
                pdf.setLineWidth(0.2);
                pdf.rect(pos.x, pos.y + 5, (width - (pos.x * 2)), 0.2, 'D');
                pdf.setFont('calibri', 'bold');
                pdf.text(`Pole ${pole.poleNumber}`, pos.x+2, pos.y+3.5);
                pdf.setFont('calibri', 'normal');
                pdf.text(`${pole.location}`, (width - (pos.x * 2)-15), pos.y+3.5);
                pos.y += 10;

                if(pole.poleReplacedOn) {
                    pdf.setFont('calibri', 'bold');
                    pdf.text(`Pole Replacement on ${convertDateFormat(pole.poleReplacedOn)} `, pos.x + 9, pos.y + 5);
                    pos.y += 6
                    if(pole.high.length + pole.medium.length + pole.low.length === 0){
                        pos.y += 1
                    }
                }

                // Check if there are high priority items
                ['High', 'Medium', 'Low'].forEach(priority => {
                    pole[priority.toLowerCase()].forEach(highItem => {
                        const startY = pos.y;
                        const imagesHeight = Math.ceil(highItem?.imageSrc?.length / 3) * 21;

                        // add image
                        if (Array.isArray(highItem.imageSrc)) {
                            // check if page has enough space for images 3 on one line
                            if (pos.y > (height - imagesHeight)) {
                                pdf.addPage();
                                pos.y = 10;
                                pageNum++; // Increment the page number
                                addPageNumber(pageNum);
                            }

                            let imageCount = 0;
                            highItem.imageSrc.forEach(imageSrc => {
                                if (imageCount < 3) {
                                    pdf.addImage(`data:image/jpeg;base64,${imageSrc}`, 'jpeg', pos.x + 102 + (imageCount * 23), pos.y, 22, 20);
                                    imageCount++;
                                } else {
                                    setPosY(pos.y + 21); // Move to the next line
                                    pdf.addImage(`data:image/jpeg;base64,${imageSrc}`, 'jpeg', pos.x + 102, pos.y, 22, 20);
                                    imageCount = 1; // Reset the count for the next line
                                }
                            });
                            // reset pos.y after adding images
                            setPosY(pos.y - (imagesHeight - 21));
                        }

                        pdf.setFont('calibri', 'bold');
                        pdf.text(`${priority}  - `, pos.x + 9, pos.y + 5);
                        pdf.setFont('calibri', 'normal');

                        // Safely get category/subCategory/remedy with null checks
                        const category = highItem.category || '';
                        const subCategory = highItem.subCategory || '';
                        const remedy = highItem.remedy || '';
                        const categoryText = `${category}\n${subCategory}\n${remedy}`.trim();
                        
                        if(categoryText) {
                            pdf.text(categoryText, pos.x + 30, pos.y + 5);
                            setPosY(pos.y + (5 * categoryText.split('\n').length));
                        }
                        
                        if(highItem.repairedOn) {
                            // Update pos.y to currentY before adding repair date and dummy fields
                            setPosY(pos.y + 5);
                            
                            pdf.setFont('calibri', 'bold');
                            const repairedDate = convertDateFormat(highItem.repairedOn);
                            if(repairedDate && repairedDate !== 'Invalid date format') {
                                pdf.text(`Repaired on ${repairedDate} `, pos.x + 30, pos.y);
                                setPosY(pos.y + 5);
                            }

                            pdf.setFont('calibri', 'bold');
                            pdf.text(`Repair Type: `, pos.x + 30, pos.y);
                            pdf.setFont('calibri', 'normal');
                            pdf.text(`${highItem.repairType}`, pos.x + 55, pos.y);
                            setPosY(pos.y + 5);
    
                            if(highItem.description && highItem.description !== null) {
                                pdf.setFont('calibri', 'bold');
                                pdf.text(`Description: `, pos.x + 30, pos.y);
                                pdf.setFont('calibri', 'normal');
                                const dummyDescription = `${highItem.description}`;
                                const maxWidth = width - (pos.x + 55);
                                const descriptionLines = pdf.splitTextToSize(dummyDescription, maxWidth);
                                if(descriptionLines && descriptionLines.length > 0) {
                                    pdf.text(descriptionLines, pos.x + 55, pos.y);
                                    setPosY(pos.y + (descriptionLines.length * 4));
                                }
                            }
                        }

                        if(pos.y < (startY + imagesHeight)) {
                            setPosY(startY + imagesHeight);
                        }
                    });
                });
                
                // Add Comments Section for the pole if available
                if(pole.comments && Array.isArray(pole.comments) && pole.comments.length > 0) {
                    pdf.setFont('calibri', 'bold');
                    pdf.setFontSize(10);
                    pdf.text('COMMENTS', pos.x + 9, pos.y + 5);
                    setPosY(pos.y + 7);
                    
                    pole.comments.forEach(comment => {
                        // Add comment text                        
                        pdf.setFont('calibri', 'normal');
                        pdf.setFontSize(8);
                        const commentText = comment ? String(comment) : '';
                        if(commentText) {
                            const maxWidth = width - (pos.x * 2) - 18;
                            const commentLines = pdf.splitTextToSize(commentText, maxWidth);
                            // Add comment text
                            if(commentLines && commentLines.length > 0) {
                                pdf.text(commentLines, pos.x + 9, pos.y + 5);
                                setPosY(pos.y + (commentLines.length * 4));
                            }
                        }
                        pdf.setFont('calibri', 'bold');
                        pdf.setFontSize(10);
                        
                        // Add comment metadata if available
                        // if(comment.createdBy || comment.createdOn) {
                        //     pdf.setFontSize(7);
                        //     pdf.setTextColor(128);
                        //     const metadata = [];
                        //     if(comment.cre`atedBy) metadata.push(`By: ${String(comment.createdBy)}`);
                        //     if(comment.createdOn) {
                        //         const commentDate = convertDateFormat(comment.createdOn);
                        //         if(commentDate && commentDate !== 'Invalid date format') {
                        //             metadata.push(`On: ${commentDate}`);
                        //         }
                        //     }
                        //     if(metadata.length > 0) {
                        //         pdf.text(metadata.join(' | '), pos.x + 9, pos.y + 3);
                        //         pos.y += 5;
                        //     }
                        //     pdf.setTextColor(0);
                        // }
                        
                        setPosY(pos.y + 3); // Space between comments
                    });
                }

            }
            if (pos.y > (height - 40)) {
                pdf.addPage();
                pos.y = 10;
                pageNum++; // Increment the page number
                addPageNumber(pageNum);
            }
        });
        

        // add school map image
        // if(pos.y > 10) {
            pdf.addPage([height, width-20], 'l');
            pos.y = 10;
            pageNum++; // Increment the page number
            addPageNumber(pageNum);
        // }
        
        const pdfHeight = width - 20;
        const pdfWidth = height - 10;
        let imageWidth = school.image.dataUrl.width;
        let imageHeight = school.image.dataUrl.height;
        
        // Calculate the aspect-ratio-preserving dimensions
        if (imageWidth > pdfWidth) {
            imageHeight *= pdfWidth / imageWidth;
            imageWidth = pdfWidth;
        }

        if (imageHeight > pdfHeight) {
            imageWidth *= pdfHeight / imageHeight;
            imageHeight = pdfHeight;
        }

        pdf.addImage(school.image.dataUrl.url, 'jpeg', 5, ((pdfHeight-imageHeight)/2), imageWidth, imageHeight);
        pos.y += 170;
        addPageNumber(pageNum);
    });
    
    pdf.save(pdfSchools.length === 1 ? `${pdfSchools[0].schoolName}.pdf` : 'Report.pdf');
};
